"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailInput = exports.isValid = void 0;
const merlin_input_1 = require("@travelnest/merlin.input");
const React = __importStar(require("react"));
// simple test for a@b.co
const isValid = (email) => email.length >= 6 && email.indexOf('@') > 0 && email.indexOf('@') < email.lastIndexOf('.');
exports.isValid = isValid;
exports.EmailInput = React.forwardRef((props, ref) => {
    return React.createElement(merlin_input_1.Input, Object.assign({}, props, { ref: ref, valid: props.invalid === undefined ? true : !props.invalid, type: "email", id: "email", onChange: (e) => {
            const email = e.target.value.trim();
            props.onChange({ email, valid: (0, exports.isValid)(email) });
        } }));
});
//# sourceMappingURL=EmailInput.js.map